import UserManagerLayout from '../components/layouts/UserManagerLayout.vue';
import UserManagerIndexPage from '../pages/UserManagerIndexPage.vue';
import UserRolesManagerIndexPage from '../pages/UserRolesManagerIndexPage.vue'
import UserPermissionsManagerIndexPage from '../pages/UserPermissionsManagerIndexPage.vue'

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
  {
    // This is the parent route for your package.
    // It uses the layout component.
    path: '/user-manager',
    name: 'user-manager.root',
    component: UserManagerLayout,
    meta: {
      requiresAuth: true,
      title: 'User Manager',
      layout: 'Authenticated',
    },
    // All other package routes are children of this layout
    children: [
      {
        path: '',
        name: 'UserManagerIndexPage',
        component: UserManagerIndexPage,
      },
      {
        path: 'roles',
        name: 'UserRolesManagerIndexPage',
        component: UserRolesManagerIndexPage,
      },
      {
        path: 'permissions',
        name: 'UserPermissionsManagerIndexPage',
        component: UserPermissionsManagerIndexPage,
      }
    ]
  }
];
